module.exports = __webpack_public_path__ + "img/volcengine.bb67d885.svg";